module.exports = __webpack_public_path__ + "static/media/Pacifico-Regular.85bb2d0e.ttf";